import React from 'react';
import { Link } from 'react-router-dom';

function StepFifteen() {
    return (
        <div className="step-form text-center">
            <div className="success-icon mb-4">
                <div
                    className="rounded-circle bg-success-subtle d-inline-flex align-items-center justify-content-center"
                    style={{ width: 80, height: 80 }}
                >
                    <img src="assets/success_icon.png" alt="Success" />
                </div>
            </div>

            <h2 className="mt-3">Thank you for completing your onboarding!</h2>
            <p className="mt-3 max-w-500 text-muted">
                Your application has been successfully submitted and is now under review by our team.
            </p>

            <p className="max-w-500 text-muted">
                To continue with the process, please click the button below to start your Occupational Health Questionnaire.</p>

            <div className="mt-4">
                <a
                    href="https://thestgroup.co.uk/health-questionnaire"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-dark px-4 py-2 text-white"
                >
                    Start Occupational Health Questionnaire
                </a>
            </div>
        </div>
    );
}

export default StepFifteen;
